import { useEffect, useState } from "react";

import {
  Checkbox,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { IconPhotoPlus } from "@tabler/icons-react";

import Image from "data/firestore/image";
import MainCard from "components/MainCard";
import PhotoGrid from "features/photos/PhotoGrid";
import CurrentSession from "data/userSession";
import useCustomNavigation from "hooks/customNavigation";

const AlbumComparison = ({ uid }) => {
  const [images, setImages] = useState([]);
  const [isOwn, setIsOwn] = useState(false);
  const [showDates, setShowDates] = useState(true);
  const navigate = useCustomNavigation();

  useEffect(() => {
    Image.list(uid, true).then(setImages);
    CurrentSession.load().then(() => {
      setIsOwn(CurrentSession.authenticationStrictlyMatches(uid));
    });
  }, [uid]);

  return (
    <MainCard
      title="Progress Photos"
      contentSX={{ padding: 1 }}
      secondary={
        isOwn ? (
          <Tooltip title="Add photo">
            <IconButton onClick={() => navigate("photos")}>
              <IconPhotoPlus />
            </IconButton>
          </Tooltip>
        ) : null
      }
    >
      {images.length === 0 ? (
        <Typography variant="overline">No progress photos</Typography>
      ) : (
        <>
          <PhotoGrid images={images} showDates={showDates} />
          <Divider sx={{ mt: 1 }} />
          <List sx={{ py: 0 }}>
            <ListItem
              disableGutters
              disablePadding
              sx={{ justifyContent: "flex-end" }}
            >
              <ListItemButton
                onClick={() => setShowDates((v) => !v)}
                sx={{ flexGrow: 0, borderRadius: 1 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <Checkbox
                    edge="start"
                    checked={showDates}
                    tabIndex={-1}
                    disableRipple
                  />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="body2">Show dates</Typography>}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </>
      )}
    </MainCard>
  );
};

export default AlbumComparison;
